import * as ActionTypes from '../constants/ActionTypes';
import * as AppEvents from '../constants/AppEvents';
import { Store } from '../utils/flux';

export default class AppEventCoordinator extends Store {
    constructor(options) {
        super(options);

        this.gridStateStore = options.gridStateStore;
    }

    /**
     * @param {object} payload
     * @param {string} payload.actionType
     * @param {Event} [payload.event]
     * @param {object} [payload.timeslot]
     * @param {string} [payload.doctorLocationId]
     */
    onDispatch(payload) {
        this.waitFor([this.gridStateStore.getDispatchToken()]);

        switch (payload.actionType) {
            case ActionTypes.CLICK_MORE_TIMES:
                this.trigger(AppEvents.CLICK_MORE_TIMES);
                break;

            case ActionTypes.CLICK_NEXT_DAYS:
                this.trigger(AppEvents.CLICK_NEXT_DAYS);
                break;

            case ActionTypes.CLICK_PREV_DAYS:
                this.trigger(AppEvents.CLICK_PREV_DAYS);
                break;

            case ActionTypes.JUMP_TO_DATE:
                this.trigger(AppEvents.JUMP_TO_DATE, {
                    date: payload.date,
                    guid: payload.guid,
                    key: payload.key,
                });
                break;

            case ActionTypes.CLICK_SLOT:
                this.trigger(AppEvents.CLICK_SLOT, {
                    doctorLocationId: payload.doctorLocationId,
                    guid: payload.guid,
                    key: payload.key,
                });
                break;

            case ActionTypes.SHOW_CONSTRAINT:
                this.trigger(AppEvents.SHOW_CONSTRAINT, {
                    event: payload.event,
                    timeslot: payload.timeslot,
                });
                break;

            default:
                break;
        }
    }
}
